import React from "react"
import style from "./gsstep.module.css"
import Image from "../image/Image"

function GsStep({text, screen1, screen2}) {
    return (
        <div className={style.step}>
            <p className={style.gstext}>{text}</p>
            <div className={style.screenspanel}>
                <div className={style.screen}>
                    <Image fluid={screen1}/>
                </div>
                <div className={style.screen}>
                    <Image fluid={screen2}/>
                </div>
            </div>
        </div>
    )
}

export default GsStep